<ion-card>
  <ion-card-header>
    <ion-card-title><ion-icon name="time-outline"></ion-icon> Automatikus KRÉTA-szinkron</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <p class="hiba" *ngIf="hiba">{{ hiba }}</p>
    <ng-container *ngIf="adat">
      <p class="halvany">
        A bekapcsolt feladatok naponta a megadott időpontokban (Budapest) futnak, előbb a csoporttagság, utána az órarend, végül a tanulói törzsadatok.
        Következő időpont: <b>{{ adat.kovetkezo || '–' }}</b>.
      </p>

      <div class="racs">
        <ion-item>
          <ion-label position="stacked">Időpontok (ÓÓ:PP, vesszővel)</ion-label>
          <ion-input [(ngModel)]="form.idopontok" placeholder="02:30, 12:30"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Órarend: hány napra előre</ion-label>
          <ion-input type="number" min="1" max="120" [(ngModel)]="form.horizont_nap"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Órarend átvételi határ (eddig a napig)</ion-label>
          <ion-input type="date" [(ngModel)]="form.atvetel_hatar"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">KRÉTA admin-fiók (csoporttagság letöltéséhez)</ion-label>
          <ion-select [(ngModel)]="form.admin_allomany" interface="popover"
                      [placeholder]="adat.beallitas?.admin_alap ? 'alapértelmezett: ' + adat.beallitas.admin_alap : 'válassz fiókot'">
            <ion-select-option value="">{{ adat.beallitas?.admin_alap ? 'Alapértelmezett (' + adat.beallitas.admin_alap + ')' : '– nincs –' }}</ion-select-option>
            <ion-select-option *ngFor="let f of adat.fiokok" [value]="f.allomany">{{ fiokNev(f) }}</ion-select-option>
          </ion-select>
        </ion-item>
      </div>
      <p class="halvany" *ngIf="adat.orarend_idoszak">
        Az órarend-átvétel most ezt az időszakot fogná: <b>{{ adat.orarend_idoszak.tol }} – {{ adat.orarend_idoszak.ig }}</b>
        ({{ adat.orarend_idoszak.mai_nap_is ? 'a mai nappal' : 'holnaptól' }}). 07:00 előtt induló futás a mai napot is átveszi, később csak holnaptól.
      </p>
      <p class="hiba" *ngIf="!adat.orarend_idoszak">
        Az átvételi határ ({{ adat.beallitas?.atvetel_hatar }}) elmúlt – az órarendet nem vesszük át, amíg ki nem tolod.
      </p>

      <div class="feladat" *ngFor="let f of feladatok">
        <div class="fej">
          <ion-checkbox [(ngModel)]="form[f.kulcs + '_enabled']"></ion-checkbox>
          <h3>{{ f.nev }}</h3>
          <ion-badge [color]="adat.beallitas?.[f.kulcs + '_enabled'] ? 'success' : 'medium'">
            {{ adat.beallitas?.[f.kulcs + '_enabled'] ? 'bekapcsolva' : 'kikapcsolva' }}
          </ion-badge>
          <div class="jobbra">
            <ion-button size="small" fill="outline" [disabled]="!!adat.fut" (click)="futtat(f.kulcs, f.nev)">
              <ion-icon slot="start" name="play"></ion-icon> Futtatás most
            </ion-button>
          </div>
        </div>
        <p class="halvany"><small>{{ f.leiras }}</small></p>
        <div class="fut" *ngIf="adat.fut?.feladat === f.kulcs">
          <ion-spinner name="crescent"></ion-spinner>
          <span>
            <b>Fut</b> ({{ adat.fut.inditotta }}) – {{ adat.fut.lepes }}
            <span *ngIf="adat.fut.osszes"> · {{ adat.fut.kesz }}/{{ adat.fut.osszes }} kolléga</span>
            <span *ngIf="adat.fut.idoszak"> · {{ adat.fut.idoszak.tol }} – {{ adat.fut.idoszak.ig }}</span>
            <span *ngIf="adat.fut.jelenlegi" class="halvany"> · {{ adat.fut.jelenlegi }}</span>
          </span>
        </div>
        <ng-container *ngIf="utolso(f.kulcs) as u">
          <p>
            Utolsó futás: <b>{{ u.indult }}</b>
            <span class="halvany"> ({{ u.inditotta }}{{ u.idopont ? ', ' + u.idopont : '' }})</span>
            <ion-badge [color]="allapotSzin(u.allapot)">{{ allapotNev(u.allapot) }}</ion-badge>
          </p>
          <p *ngIf="u.osszegzes"><small>{{ u.osszegzes }}</small></p>
          <p *ngIf="u.eredmeny?.tol"><small>Átvett időszak: <b>{{ u.eredmeny.tol }} – {{ u.eredmeny.ig }}</b>
            ({{ u.eredmeny.mai_nap_is ? 'a mai nappal' : 'holnaptól' }})</small></p>
          <ul *ngIf="u.eredmeny?.figyelmeztetes?.length">
            <li *ngFor="let w of u.eredmeny.figyelmeztetes" class="hiba"><small>{{ w }}</small></li>
          </ul>
          <ul *ngIf="u.eredmeny?.hibak?.length">
            <li *ngFor="let h of u.eredmeny.hibak" class="hiba"><small>{{ h.nev }}: {{ h.hiba }}</small></li>
          </ul>
          <details *ngIf="u.eredmeny?.valtozott?.length">
            <summary><small>Változott csoportok ({{ u.eredmeny.valtozott.length }})</small></summary>
            <ul><li *ngFor="let c of u.eredmeny.valtozott"><small>{{ c.nev }}: +{{ c.uj }} / –{{ c.lezart }}</small></li></ul>
          </details>
          <details *ngIf="u.eredmeny?.tanarok?.length">
            <summary><small>Érintett kollégák ({{ u.eredmeny.tanarok.length }})</small></summary>
            <ul><li *ngFor="let t of u.eredmeny.tanarok"><small>{{ t.nev }}: +{{ t.felvett }} új, {{ t.frissitett }} frissítve,
              {{ t.athelyezett }} áthelyezve, {{ t.torolt }} törölve</small></li></ul>
          </details>
          <details *ngIf="elozmenyek(f.kulcs).length">
            <summary><small>Korábbi futások</small></summary>
            <ul><li *ngFor="let e of elozmenyek(f.kulcs)"><small>{{ e.indult }} · {{ allapotNev(e.allapot) }} · {{ e.osszegzes }}</small></li></ul>
          </details>
        </ng-container>
        <p class="halvany" *ngIf="!utolso(f.kulcs)"><small>Még nem futott.</small></p>
      </div>

      <ion-button (click)="ment()" [disabled]="mentes">
        <ion-icon slot="start" name="save-outline"></ion-icon> Beállítás mentése
      </ion-button>
      <span class="halvany" *ngIf="adat.beallitas?.modositotta"><small> Utoljára módosította: {{ adat.beallitas.modositotta }} ({{ adat.beallitas.modositva }})</small></span>

      <h4>KRÉTA-ban átvezetendő ({{ adat.kivetelek?.length || 0 }})</h4>
      <p class="halvany"><small>
        Kézi javítás védett: ezeknél a Sulinform tagsága kézzel eltér a KRÉTÁ-tól, ezért az átvétel nem írja vissza.
        Ha a KRÉTÁ-ban is átvezetik, a következő futás magától leveszi a listáról.
      </small></p>
      <div class="tabla-wrap" *ngIf="adat.kivetelek?.length">
        <table class="lista">
          <thead><tr><th>Tanuló</th><th>Csoport</th><th>Irány</th><th>Mióta</th><th>Megjegyzés</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let k of adat.kivetelek">
              <td>{{ k.tanulo_nev || k.tanulo }}</td>
              <td>{{ k.csoport_nev || k.csoport }}</td>
              <td>
                <ion-badge [color]="k.irany === 'bent' ? 'success' : 'warning'">
                  {{ k.irany === 'bent' ? 'bent marad' : 'kint marad' }}
                </ion-badge>
              </td>
              <td>{{ k.kezdete || (k.letrehozva | slice:0:10) }}</td>
              <td><small>{{ k.megjegyzes }}</small><br><small class="halvany">{{ k.letrehozta }}</small></td>
              <td><ion-button size="small" fill="clear" color="danger" (click)="kivetelTorol(k)">Törlés</ion-button></td>
            </tr>
          </tbody>
        </table>
      </div>

      <h4>A többi automatikus KRÉTA-feladat</h4>
      <div class="tabla-wrap">
        <table class="lista">
          <thead><tr><th>Feladat</th><th>Állapot</th><th>Gyakoriság</th><th>Utolsó futás</th><th>Eredmény</th></tr></thead>
          <tbody>
            <tr *ngFor="let t of tobbiLista">
              <td>{{ t.nev }}</td>
              <td><ion-badge [color]="t.bekapcsolva ? 'success' : 'medium'">{{ t.bekapcsolva ? 'bekapcsolva' : 'kikapcsolva' }}</ion-badge></td>
              <td><small>{{ t.gyakorisag || '–' }}</small></td>
              <td><small>{{ t.utolso_futas || '–' }}</small></td>
              <td><small>{{ t.utolso_eredmeny || '–' }}</small></td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
